// src/components/GoogleAnalytics.js - Corrected implementation
import { useEffect } from 'react';
import { getBrand } from '../utils/getBrand';

const GoogleAnalytics = () => {
  useEffect(() => {
    const { brandGA4Id } = getBrand();
    const win = /** @type {any} */ (window);

    // Only load real GA in production
    if (process.env.NODE_ENV === 'production') {
      // Create and load the gtag script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${brandGA4Id}`;
      document.head.appendChild(script);

      // Initialize gtag
      win.dataLayer = win.dataLayer || [];
      function gtag() {
        win.dataLayer.push(arguments);
      }
      win.gtag = gtag;

      gtag('js', new Date());

      // Configure GA with automatic page views disabled
      gtag('config', brandGA4Id);

      console.log('Google Analytics initialized in production mode');
    } else {
      // Mock gtag for development
      win.gtag = function () {
        console.log('Google Analytics (development):', ...arguments);
      };

      console.log('Google Analytics mock initialized in development mode');
    }
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
